/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-danger */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { LaptopOutlined, MinusOutlined, MobileOutlined, ReloadOutlined } from '@ant-design/icons';
import {
	Breadcrumb,
	Button,
	DatePicker,
	Input,
	message,
	Modal,
	Select,
	Space,
	Spin,
	Tag,
	Tooltip,
} from 'antd';
import dayjs, { utc } from 'dayjs';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDetailedLogsByCriteriaPaged, getLogDetails } from '../../redux/auditLogSlice';
import { style } from '../../Styles';

import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { detailedAuditLogActions } from '../../Utils/AuditLogsDescriptions';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import { formatDateAndTime } from '../../Utils/date-utils';
import { getSimpleUsersList } from '../../redux/userSlice';
import { entityLabels, documentTypeLabels } from '../../Utils/Constants/entityMapper';
import DocumentComponent from '../Global/DocumentComponent/DocumentComponent';

import AuditChangeValue from './AuditChangeValue';
import AuditDetailValue from './AuditDetailValue';
import { formatFieldLabel } from '../../Utils/Constants/utils';

const dateFormat = 'YYYY/MM/DD';
const { RangePicker } = DatePicker;
const today = dayjs().startOf('day');
const todayEnd = dayjs().endOf('day');
dayjs.extend(utc);

const DOCUMENT_FIELD_REGEX = /documentChanges/i;

const isDocumentField = (field) => DOCUMENT_FIELD_REGEX.test(field);

const DetailedAuditLogs = ({ makingApiCall, setMakingApiCall, role }) => {
	const { logs } = useSelector((state) => state.auditLog);
	const {
		simpleUsersList: { loading: usersLoading, usersList },
	} = useSelector((state) => state.users);

	const data = logs?.detailedLogs ?? [];
	DetailedAuditLogs.propTypes = {
		makingApiCall: PropTypes.bool.isRequired,
		setMakingApiCall: PropTypes.func.isRequired,
		role: PropTypes.string.isRequired,
	};
	const dispatch = useDispatch();
	const columnSortMap = {
		id: 'id',
		created: 'created',
		user: 'user.name',
		description: 'details',
		source: 'source',
	};
	const [dateRange, setDateRange] = useState([today, todayEnd]);
	const [sortedInfo, setSortedInfo] = useState({ columnKey: null, order: null });
	const [selectedAction, setSelectedAction] = useState(null);
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedEntity, setSelectedEntity] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const [search, setSearch] = useState('');
	const [detailsModalOpen, setDetailsModalOpen] = useState(false);
	const [detailsModalTitle, setDetailsModalTitle] = useState('');
	const [selectedEntityChanges, setSelectedEntityChanges] = useState(null);
	const [selectedAudit, setSelectedAudit] = useState(null);
	const [entityDetailsLoading, setEntityDetailsLoading] = useState(false);
	const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
	const [selectedDocuments, setSelectedDocuments] = useState([]);

	const closeDocumentsModal = () => {
		setDocumentsModalOpen(false);
		setSelectedDocuments([]);
	};

	const isSensitiveField = (field) => {
		return /pass(word)?|pwd|secret/i.test(field);
	};

	const searchTimerRef = useRef(null);
	const fetchAllUsers = useCallback(async () => {
		setMakingApiCall(true);
		dispatch(getSimpleUsersList())
			.unwrap()
			.then(() => {})
			.catch(() => {
				message.error('Error while fetching users');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	}, []);

	const handleViewEntity = (id, entity) => {
		setSelectedEntityChanges(null);
		setDetailsModalTitle(entityLabels[entity] || entity);
		setDetailsModalOpen(true);
		setEntityDetailsLoading(true);

		dispatch(getLogDetails({ id, entity }))
			.unwrap()
			.then((response) => {
				setSelectedAudit(response);
			})
			.catch(() => {
				setDetailsModalTitle('');
				setDetailsModalOpen(false);
				message.error('Error while fetching entity details');
			})
			.finally(() => {
				setEntityDetailsLoading(false);
			});
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortedInfo({ columnKey: sorter.columnKey, order: sorter.order });
		} else {
			setSortedInfo((prev) => ({
				columnKey: sorter.columnKey || prev.columnKey,
				order: prev.order === 'ascend' ? 'descend' : 'ascend',
			}));
		}
		setCurrentPage(1);
	};

	const getActionTag = (action) => {
		const normalizedAction = action?.toLowerCase();

		let color = 'blue';

		if (normalizedAction.includes('created')) {
			color = 'green';
		} else if (normalizedAction.includes('updated')) {
			color = 'orange';
		} else if (normalizedAction.includes('deleted')) {
			color = 'red';
		}

		return <Tag color={color}>{action}</Tag>;
	};
	const renderAuditDetails = (details, relatedAction) => {
		if (!details) return <MinusOutlined />;

		const match = details.match(/User (.+?) (.+?) (.+?) (.+?) \(ID: (\d+)\) at .+/);

		if (!match) {
			return <span>{details}</span>;
		}

		const [, name, surname, action, entity, id] = match;

		return (
			<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
				<span style={{ fontWeight: 600 }}>
					{name} {surname}
				</span>

				{getActionTag(action)}

				<Tag color='purple'>{entityLabels[entity] || entity}</Tag>

				{relatedAction === 'UPDATE_ENTITY' ? (
					<code
						style={{
							background: '#f5f5f5',
							padding: '2px 6px',
							borderRadius: 4,
						}}>
						ID {id}
					</code>
				) : (
					<Button
						type='link'
						onClick={() => {
							handleViewEntity(id, entity);
						}}
						style={{
							padding: '2px 6px',
							height: 'auto',
							fontFamily: 'monospace',
							background: '#f5f5f5',
							borderRadius: 4,
						}}>
						ID {id}
					</Button>
				)}
			</div>
		);
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'id' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: 'Date',
			key: 'created',
			render: (record) => {
				return record?.created ? formatDateAndTime(record?.created) : <MinusOutlined />;
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'created' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
			width: '12%',
		},
		{
			title: 'User',
			key: 'user',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'user' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
			render: (record) => {
				const fullName = `${record?.user?.name} ${record?.user?.surname} `;
				return record?.user ? (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{record?.user?.profilePicture ? (
							<ImageComponent size={40} imageId={record?.user?.profilePicture} />
						) : (
							<CustomAvatar name={fullName} type='initials' />
						)}
						<span>{`${record?.user?.name} ${record?.user?.surname} `}</span>
						{!record.user?.active ? (
							<span style={{ color: 'GrayText', fontSize: '12px' }}>(Inactive)</span>
						) : null}
					</div>
				) : (
					<MinusOutlined />
				);
			},
		},
		{
			title: 'Action',
			key: 'description',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'description' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
			render: (record) => {
				return renderAuditDetails(record?.details, record?.action);
			},
		},
		{
			title: 'Entity',
			key: 'entity',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'entity' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
			render: (record) => {
				return (
					<Tag color='purple'>
						{entityLabels[record?.entityType] || record?.entityType}
					</Tag>
				);
			},
		},

		{
			title: 'Source',
			key: 'source',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'source' ? sortedInfo.order : null,
			sortDirections: ['ascend', 'descend'],
			render: (record) => {
				return record?.source ? (
					record?.source === 'WEB_APP' ? (
						<span style={style.dataContainer}>
							<div
								style={{
									...style.statusCompleted,
									display: 'flex',
									justifyContent: 'center',
									gap: '5px',
								}}>
								<LaptopOutlined />
								Web App
							</div>
						</span>
					) : record?.source === 'RIDER_APP' ? (
						<span style={style.dataContainer}>
							<div
								style={{
									...style.statusInProgress,
									display: 'flex',
									justifyContent: 'center',
									gap: '5px',
								}}>
								<MobileOutlined />
								Rider App
							</div>
						</span>
					) : record?.source === 'DRIVER_APP' ? (
						<span style={style.dataContainer}>
							<div
								style={{
									...style.statusAccepted,
									display: 'flex',
									justifyContent: 'center',
									gap: '5px',
								}}>
								<MobileOutlined />
								Driver App
							</div>
						</span>
					) : null // Added null as a placeholder for the last condition
				) : (
					<MinusOutlined />
				);
			},
		},
		{
			title: 'Changes',
			key: 'details',
			align: 'center',
			render: (record) => {
				const details = record?.details?.toLowerCase();

				if (details?.includes('updated')) {
					return (
						<Button
							type='link'
							onClick={() => {
								setSelectedEntityChanges(record.entityChanges);
								setDetailsModalTitle('');
								setSelectedAudit(null);
								setDetailsModalOpen(true);
							}}>
							View Details
						</Button>
					);
				}

				return <Tag color='default'>N/A</Tag>;
			},
		},
	];

	const onDateRangeChange = (value) => {
		setDateRange(value);
		if (value && value[1].diff(value[0], 'day') > 90) {
			message.warning('Large date ranges may take longer to load.');
		}
	};

	const fetchAuditLogs = useCallback(async () => {
		setMakingApiCall(true);

		const start = dateRange[0].format('YYYY-MM-DD');
		const end = dateRange[1].format('YYYY-MM-DD');
		const sortBy = (sortedInfo.columnKey && columnSortMap[sortedInfo.columnKey]) || 'created';
		const sortDirection = sortedInfo.order === 'ascend' ? 'ASC' : 'DESC';

		dispatch(
			getDetailedLogsByCriteriaPaged({
				data: {
					start,
					end,
					action: selectedAction,
					userId: selectedUser,
					entityType: selectedEntity,
					search,
				},
				page: currentPage - 1,
				size: pageSize,
				sortBy,
				sortDirection,
			}),
		)
			.unwrap()
			.catch(() => {
				message.error('Error while fetching audit logs');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	}, [
		dateRange,
		selectedAction,
		selectedUser,
		selectedEntity,
		search,
		sortedInfo,
		currentPage,
		pageSize,
		dispatch,
	]);

	useEffect(() => {
		fetchAuditLogs();
	}, [fetchAuditLogs]);

	useEffect(() => {
		fetchAllUsers();
	}, [fetchAllUsers]);
	return (
		<Spin spinning={makingApiCall} delay={500}>
			<div
				style={{
					borderRadius: '17px',
					background: '#ffffff',
					marginTop: '1em',
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'System Audit Log',
								},
							]}
						/>
						<Button type='default' size='small' onClick={() => fetchAuditLogs()}>
							<ReloadOutlined />
						</Button>
					</div>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'center',
							marginBottom: 8,
						}}>
						<RangePicker
							onChange={onDateRangeChange}
							defaultValue={dateRange}
							format={dateFormat}
							style={{ width: '100%', margin: '0 8px 8px 0' }}
							allowClear={false}
							disabledDate={(current) => current && current > dayjs().endOf('day')}
						/>
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Select
							placeholder='Select action'
							style={{ margin: '0 8px 8px 0', width: '13em' }}
							allowClear
							onClear={() => setSelectedAction(null)}
							onChange={(value) => {
								setSelectedAction(value);
							}}>
							{detailedAuditLogActions.map((item) => (
								<Select.Option key={item.value} value={item.value}>
									{item.label}
								</Select.Option>
							))}
						</Select>
						<Select
							placeholder='Select user'
							style={{ margin: '0 8px 8px 0', width: '10em' }}
							allowClear
							showSearch
							optionFilterProp='filterBy'
							optionLabelProp='label'
							loading={usersLoading}
							onClear={() => setSelectedUser(null)}
							onChange={(value) => {
								setSelectedUser(value);
							}}>
							{Object.values(usersList)?.map((item) => (
								<Select.Option
									key={item.id}
									value={item.id}
									label={
										<div style={style.inlineContent}>
											<Tooltip title={`${item.name}`}>
												<span>{`${item.name}`}</span>
											</Tooltip>
										</div>
									}
									filterBy={`${item.name}`}>
									<div style={style.inlineContent}>
										<Tooltip title={`${item.name}`}>
											<span
												style={{
													marginLeft: '8px',
												}}>{`${item.name}`}</span>
										</Tooltip>
									</div>
								</Select.Option>
							))}
						</Select>
						<Select
							placeholder='Select entity'
							style={{ margin: '0 8px 8px 0', width: '10em' }}
							allowClear
							showSearch
							optionFilterProp='filterBy'
							optionLabelProp='label'
							loading={usersLoading}
							onClear={() => setSelectedEntity(null)}
							onChange={(value) => {
								setSelectedEntity(value);
							}}>
							{Object.entries(entityLabels)?.map(([key, item]) => (
								<Select.Option
									key={key}
									value={key}
									label={
										<div style={style.inlineContent}>
											<Tooltip title={`${item}`}>
												<span>{`${item}`}</span>
											</Tooltip>
										</div>
									}
									filterBy={`${item}`}>
									<div style={style.inlineContent}>
										<Tooltip title={`${item}`}>
											<span
												style={{
													marginLeft: '8px',
												}}>{`${item}`}</span>
										</Tooltip>
									</div>
								</Select.Option>
							))}
						</Select>
						<Input.Search
							placeholder='Search'
							style={{ margin: '0 8px 8px 0', width: '12em' }}
							allowClear
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={makingApiCall}
					columns={columns}
					dataArray={data}
					handleDoubleClickRow={() => {}}
					handleSelectedRow={() => {}}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: logs?.detailedLogsTotal || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</div>
			<Modal
				title={
					selectedEntityChanges
						? `Audit Log Details (${Object.keys(selectedEntityChanges).length})`
						: `${detailsModalTitle} Details`
				}
				open={detailsModalOpen}
				onCancel={() => {
					setDetailsModalTitle('');
					setDetailsModalOpen(false);
					setSelectedEntityChanges(null);
					setSelectedAudit(null);
				}}
				footer={null}
				width={750}
				styles={{
					body: {
						maxHeight: '65vh',
						overflowY: 'auto',
						paddingRight: 8,
					},
				}}>
				{selectedEntityChanges && (
					<div
						style={{
							border: '1px solid #f0f0f0',
							borderRadius: 8,
							overflow: 'hidden',
						}}>
						<div
							style={{
								display: 'grid',
								gridTemplateColumns: '1fr 1.2fr 32px 1.2fr',
								gap: 12,
								padding: '10px 14px',
								background: '#fafafa',
								borderBottom: '1px solid #f0f0f0',
								fontSize: 12,
								fontWeight: 600,
								color: '#8c8c8c',
							}}>
							<div>FIELD</div>
							<div>PREVIOUS</div>
							<div />
							<div>CURRENT</div>
						</div>

						{Object.entries(selectedEntityChanges)
							.filter(([field, values]) => {
								const isDocumentChange = isDocumentField(field);

								if (
									isDocumentChange &&
									!(
										Array.isArray(values.new) &&
										Array.isArray(values.old) &&
										values.new.length === 0 &&
										values.old.length === 0
									)
								) {
									return true;
								}

								return JSON.stringify(values.old) !== JSON.stringify(values.new);
							})
							.map(([field, values], index) => {
								const isDocumentChange = isDocumentField(field);
								const transparentBackground =
									field === 'vehicleTypeChanges' ||
									field === 'assignedDriversChanges';

								return (
									<div
										key={field}
										style={{
											display: 'grid',
											gridTemplateColumns: isDocumentChange
												? '1fr 3.4fr'
												: '1fr 1.2fr 32px 1.2fr',
											gap: 12,
											alignItems: 'center',
											padding: '12px 14px',
											borderBottom:
												index ===
												Object.keys(selectedEntityChanges).length - 1
													? 'none'
													: '1px solid #f0f0f0',
										}}>
										<div
											style={{
												fontWeight: 600,
												color: '#262626',
												overflowWrap: 'anywhere',
											}}>
											{formatFieldLabel(field)}
										</div>

										{isDocumentChange ? (
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<Button
													type='link'
													onClick={() => {
														setSelectedDocuments(
															Array.isArray(values.new)
																? values.new
																: [],
														);
														setDocumentsModalOpen(true);
													}}>
													View current documents
												</Button>
											</div>
										) : (
											<>
												<div
													style={{
														padding: '7px 10px',
														borderRadius: 6,
														background: transparentBackground
															? 'transparent'
															: '#fff1f0',
														border: transparentBackground
															? 'none'
															: '1px solid #ffccc7',
														color: '#cf1322',
														overflowWrap: 'anywhere',
														wordBreak: 'break-word',
														minWidth: 0,
													}}>
													<AuditChangeValue
														field={field}
														value={values.old}
														old
													/>
												</div>

												<div
													style={{
														textAlign: 'center',
														color: '#bfbfbf',
														fontSize: 18,
													}}>
													→
												</div>

												<div
													style={{
														padding: '7px 10px',
														borderRadius: 6,
														background: transparentBackground
															? 'transparent'
															: '#f6ffed',
														border: transparentBackground
															? 'none'
															: '1px solid #b7eb8f',
														color: '#389e0d',
														overflowWrap: 'anywhere',
														wordBreak: 'break-word',
														minWidth: 0,
													}}>
													<AuditChangeValue
														field={field}
														value={values.new}
													/>
												</div>
											</>
										)}
									</div>
								);
							})}
					</div>
				)}

				{!selectedEntityChanges && entityDetailsLoading && (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: 200,
						}}>
						<Spin size='large' />
					</div>
				)}

				{!selectedEntityChanges && !entityDetailsLoading && selectedAudit && (
					<div
						style={{
							border: '1px solid #f0f0f0',
							borderRadius: 8,
							overflow: 'hidden',
						}}>
						<div
							style={{
								padding: '10px 14px',
								background: '#fafafa',
								borderBottom: '1px solid #f0f0f0',
								fontSize: 12,
								fontWeight: 600,
								color: '#8c8c8c',
							}}>
							DETAILS
						</div>

						{Object.entries(selectedAudit)
							.filter(
								([field]) =>
									!isSensitiveField(field) && field.toLowerCase() !== 'tenantid',
							)
							.map(([field, value], index, entries) => (
								<AuditDetailValue
									key={field}
									field={field}
									value={value}
									index={index}
									entries={entries}
								/>
							))}
					</div>
				)}
			</Modal>
			<Modal
				title='Documents'
				open={documentsModalOpen}
				onCancel={closeDocumentsModal}
				footer={null}
				width={650}
				styles={{
					body: {
						maxHeight: '65vh',
						overflowY: 'auto',
						paddingRight: 8,
					},
				}}>
				{selectedDocuments.length === 0 ? (
					<div style={{ color: '#8c8c8c' }}>No documents uploaded</div>
				) : (
					<Space direction='vertical' size={12} style={{ width: '100%' }}>
						{[...selectedDocuments]
							.sort((a, b) => dayjs(b.created).valueOf() - dayjs(a.created).valueOf())
							.map((document) => (
								<div
									key={document.id}
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 16,
										padding: 14,
										border: '1px solid #e8e8e8',
										borderRadius: 10,
										background: '#fff',
										boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
									}}>
									<div
										style={{
											flexShrink: 0,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											width: 100,
											height: 100,
											borderRadius: 8,
											background: '#fafafa',
											border: '1px solid #f0f0f0',
											overflow: 'hidden',
										}}>
										<DocumentComponent documentId={document.id} size={100} />
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											gap: 8,
											minWidth: 0,
										}}>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: 8,
											}}>
											<Tag color='blue' style={{ margin: 0 }}>
												{documentTypeLabels[document.documentType] ||
													document.documentType ||
													'Document'}
											</Tag>
										</div>

										<div
											style={{
												display: 'flex',
												flexWrap: 'wrap',
												gap: '6px 20px',
												fontSize: 13,
												color: '#595959',
											}}>
											<div>
												<span style={{ color: '#8c8c8c' }}>Expiry: </span>
												<span>
													{document.expiryDate
														? dayjs(document.expiryDate).format(
																'YYYY/MM/DD',
														  )
														: 'None'}
												</span>
											</div>

											<div>
												<span style={{ color: '#8c8c8c' }}>Created: </span>
												<span>
													{document.created
														? dayjs(document.created).format(
																'YYYY/MM/DD HH:mm',
														  )
														: 'None'}
												</span>
											</div>
										</div>
									</div>
								</div>
							))}
					</Space>
				)}
			</Modal>
		</Spin>
	);
};

export default DetailedAuditLogs;
